export const getNotificationConfirmationData = (action, count, translations) => {
  const requestText =
    count === 1 ? translations?.confirmSingleRequest : translations?.confirmMultipleRequests

  return {
    header: `${action} Selected Requests`,
    body: requestText.replace('{action}', `"${action}"`).replace('{count}', count),
    cancelText: 'Back',
    confirmText: `Yes, ${action}`,
    color: action === 'approve' ? '#29CC8B' : '#FC5A5A',
  }
}
export const selectRequestInboxModalData = (action, employeeName, requestType, translations) => ({
  header: `${action} a Request`,
  body: translations?.confirmVacationRequest
    .replace('{action}', `"${action}"`)
    .replace('{requestType}', requestType)
    .replace('{employeeName}', employeeName),
  cancelText: 'No',
  confirmText: `Yes, ${action}`,
  color: action === 'approve' ? '#29cc8b' : '#ff6f61',
})
